export function createVisibleEngagementTimer({
  initialElapsed = 0,
  now = () => performance.now(),
  schedule = setTimeout,
  cancel = clearTimeout,
  onProgress = () => {},
  onComplete,
}) {
  const threshold = 10000;
  let elapsed = Math.min(threshold, Math.max(0, Number(initialElapsed) || 0));
  let started = null;
  let timeout = null;
  let completed = false;

  const finish = () => {
    if (completed) return;
    completed = true;
    elapsed = threshold;
    started = null;
    timeout = null;
    onProgress(elapsed);
    onComplete();
  };

  return {
    setVisible(visible) {
      if (completed) return;
      if (!visible) {
        if (timeout !== null) cancel(timeout);
        timeout = null;
        if (started !== null) elapsed += Math.max(0, now() - started);
        started = null;
        onProgress(Math.min(threshold, elapsed));
        if (elapsed >= threshold) finish();
      } else if (started === null) {
        if (elapsed >= threshold) return finish();
        started = now();
        timeout = schedule(finish, threshold - elapsed);
      }
    },
  };
}
